import { motion } from 'framer-motion';
import { ArrowRight, Clock } from 'lucide-react';

const posts = [
  {
    title: 'What Makes a Website Convert Visitors Into Customers',
    excerpt: 'The difference between a pretty website and one that drives business results comes down to strategy, not aesthetics.',
    category: 'Strategy',
    readTime: '5 min read',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop',
  },
  {
    title: 'Why Small Businesses Need Professional Web Design',
    excerpt: 'Your website is often the first impression potential customers get. Here is why cutting corners costs more in the long run.',
    category: 'Business',
    readTime: '4 min read',
    image: 'https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=600&h=400&fit=crop',
  },
  {
    title: 'The Real Cost of a Bad Website',
    excerpt: 'Slow load times, poor mobile experience, and confusing navigation are silently killing your conversions.',
    category: 'Performance',
    readTime: '6 min read',
    image: 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=600&h=400&fit=crop',
  },
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.15 }
  }
};

const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

const Blog = () => {
  return (
    <section id="blog" className="py-24 bg-white dark:bg-dark">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-highlight font-medium text-sm uppercase tracking-wider">Blog</span>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-primary dark:text-white mt-3 mb-4">
            Insights &amp; Resources
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto text-lg">
            Straight talk on web design, strategy, and growing your business online.
          </p>
        </motion.div>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          className="grid md:grid-cols-3 gap-8"
        >
          {posts.map((post) => (
            <motion.article
              key={post.title}
              variants={item}
              className="group bg-gray-50 dark:bg-secondary/50 rounded-2xl overflow-hidden hover:shadow-lg transition-all duration-300"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-3 py-1 bg-highlight/10 text-highlight text-xs font-semibold rounded-full">
                    {post.category}
                  </span>
                  <span className="flex items-center gap-1 text-gray-400 text-xs">
                    <Clock size={12} />
                    {post.readTime}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-primary dark:text-white mb-2 group-hover:text-highlight transition-colors">
                  {post.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm mb-4">{post.excerpt}</p>
                <button className="text-sm font-semibold text-primary dark:text-white flex items-center gap-1 group-hover:text-highlight transition-colors">
                  Read more <ArrowRight size={14} />
                </button>
              </div>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Blog;
